// POLYFILLS, keep at the top
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './utils/store';
import 'ie-array-find-polyfill';
import './index.css';
import AppContainer from './app/AppContainer';
import ErrorRedirectService from './routes/error/errorRedirect.service.ts';
import { initChallengerMain } from './utils/challengerMain';
import * as webStorage from '@com.rakuten.esd/myr-web-storage';
import { WHITELIST_ROUTES } from './app/app.constants';
import { configureZxcvbn } from './zxcvbn';

initChallengerMain().then(() => {
    const locale = localStorage.getItem('userSetLocale') || 'en';
    configureZxcvbn(locale);
    if (!global.Intl) {
        Promise.all([import('intl'), import('intl/locale-data/jsonp/en.js')]).then(() => {
            ReactDOM.render(
                <Provider store={store}>
                    <AppContainer />
                </Provider>,
                document.getElementById('root'),
            );
        });
    } else {
        ReactDOM.render(
            <Provider store={store}>
                <AppContainer />
            </Provider>,
            document.getElementById('root'),
        );
    }
});

window.addEventListener(
    'pageshow',
    (event) => {
        if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
            window.location.reload();
        }

        function checkAccessTokenPresence() {
            const accessToken = webStorage.getAccessToken();
            if (!accessToken) {
                return '';
            }
            return accessToken;
        }

        if (
            !WHITELIST_ROUTES.includes(window.location.pathname) &&
            window.location.pathname.indexOf('/error') === -1 &&
            !checkAccessTokenPresence() &&
            navigator.userAgent.toLowerCase().indexOf('firefox') > -1
        ) {
            ErrorRedirectService.notLoggedIn();
        }
    },
    false,
);
